export var TOGGLE_FILTER = '[SEARCH VIDEOS] TOGGLE FILTER';
export var CHANGE_SEARCH = '[SEARCH VIDEOS] CHANGE SEARCH';
export var RESET_SEARCH_FILTER = '[SEARCH VIDEOS] RESET SEARCH FILTER';
export var toggleSearchVideoFilter = function (key, filter) { return function (dispatch) {
    return dispatch({
        type: TOGGLE_FILTER,
        payload: { key: key, filter: filter },
    });
}; };
export var resetSearchVideoFilter = function (key, filter) { return function (dispatch) {
    return dispatch({
        type: RESET_SEARCH_FILTER,
        payload: {
            key: '',
            filter: '',
        },
    });
}; };
export var changeSearchVideo = function (value) { return function (dispatch) {
    return dispatch({
        type: CHANGE_SEARCH,
        payload: {
            key: value,
            filter: '',
        },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/searchVideos.actions.ts
// module id = 601
// module chunks = 81